import { render } from "./Form.vue?vue&type=template&id=04a9e87c&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=04a9e87c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04a9e87c"

export default script